module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"editMediation":"Edit a mediation"},"fr":{"editMediation":"Editer une médiation"}}')
  delete Component.options._Ctor
}
